import { render } from "./ProvenanceImageOverlay.vue?vue&type=template&id=11761422&scoped=true"
import script from "./ProvenanceImageOverlay.vue?vue&type=script&lang=js"
export * from "./ProvenanceImageOverlay.vue?vue&type=script&lang=js"

import "./ProvenanceImageOverlay.vue?vue&type=style&index=0&id=11761422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11761422"]])

export default __exports__